import React from 'react';
import {PropTypes} from 'prop-types';
import numeral from 'numeral';
import {ErrorsBlockComponent} from '../../shared/errorsBlockComponent';
import {RefreshButtonComponent} from '../../shared/refreshButtonComponent';
import {SimpleLineChart, NormalizeDataTable} from '../../shared/Charts';
import {PageHeader} from '../../shared/PageHeader';
import {MakeApiCall, FormatString, ToString, ObjectToQueryString, ReplaceUrl, IsVersionFilterValid} from '../../shared/utils';

import './styles.scss';

const CHART_WIDTH = 120;
const CHART_HEIGHT = 70;

export class AppErrorsComponent extends React.Component {
    constructor(props, ...others) {
        super(props, ...others);
        this.state = {
            isLoaded: false,
            isLoading: false,
            errors: [],
            errorsCount: props.errorsCount,
            daysDepth: props.daysDepth,
            applicationTypeId: props.applicationTypeId,
            versionFilter: props.versionFilter,
            loadErrors: null,
            requestId: 0
        }

        this.doLoad = this.doLoad.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const self = this;

        self._isMounted = true;
        self.doLoad();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleSubmit(event) {
        event.preventDefault();
        this.doLoad();
    }

    doLoad() {
        const self = this;
        if (!self._isMounted) {
            return;
        }

        const requestId = self.state.requestId + 1;
        const {errorsSource, versionFilterAllowed} = self.props;
        const {daysDepth, errorsCount, applicationTypeId, versionFilter} = self.state;

        // const data = {
        //     daysDepth: daysDepth,
        //     applicationTypeId: applicationTypeId,
        //     errorsCount: errorsCount,
        //     versionFilter: versionFilterAllowed ? versionFilter : null
        // }

        const data = {
            dd: daysDepth,
            at: applicationTypeId,
            ec: errorsCount,
            vf: versionFilterAllowed ? versionFilter : null
        }

        new Promise(resolve => {
            self.setState({isLoading: true, loadErrors: null, requestId: requestId}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                ReplaceUrl({
                    pathname: window.location.pathname,
                    search: ObjectToQueryString(data, true, {ec: 20, dd: 14})
                });

                return MakeApiCall(
                    $.get(
                        {
                            url: errorsSource,
                            data: data,
                            dataType: 'json',
                            cache: false
                        }
                    ),
                    false,
                    () => !self._isMounted || (self.state.requestId != requestId)
                );
            }
        })
        .then(responseData => {
            if (self._isMounted && (requestId == self.state.requestId)) {
                self.setState(
                    {
                        isLoading: false, 
                        isLoaded: true, 
                        daysDepth: responseData.dd,
                        errorsCount: responseData.ec,
                        applicationTypeId: responseData.at,
                        versionFilter: responseData.vf,
                        errors: responseData.Errors
                            .map(p => {
                                p.StatsByDay = NormalizeDataTable(p.StatsByDay);
                                return p
                            })
                    });
            }
        })
        .catch(errors => {
            if (self._isMounted && (requestId == self.state.requestId)) {
                self.setState({isLoading: false, loadErrors: errors});
            }
        });
    }

    renderForm() {
        const self = this;
        const {isLoading, applicationTypeId, versionFilter: _versionFilter} = self.state;
        const {versionFilterAllowed} = self.props;
        const isDisabled = isLoading;
        const versionFilter = ToString(_versionFilter);
        const isVersionFilterValid = !versionFilterAllowed || IsVersionFilterValid(versionFilter.trim());

        return (
            <div className="mb-n2 mt-2">
                <form className="form-inline align-items-baseline" onSubmit={self.handleSubmit}>
                    <select
                        className="custom-select mr-2 mb-2"
                        disabled={isDisabled}
                        value={ToString(applicationTypeId)}
                        onChange={e => self.setState({applicationTypeId: e.target.value})}
                    >
                        {self.props.applicationTypes.map(p => <option key={p.Key} value={p.Key}>{p.Value}</option>)}
                    </select>
                    {versionFilterAllowed &&
                        <input 
                            type="text"
                            className={'form-control mr-2 mb-2' + (isVersionFilterValid ? '' : ' is-invalid')}
                            placeholder="App version"
                            style={{width: '150px', maxWidth: '100%'}}
                            disabled={isDisabled}
                            value={versionFilter}
                            onChange={e => self.setState({versionFilter: e.target.value})}
                        />
                    }
                    <RefreshButtonComponent 
                        type="submit"
                        disabled={isDisabled || !isVersionFilterValid}
                        animated={isLoading}
                    />
                </form>
            </div>
        )
    }

    render() {
        const self = this;
        const {isLoaded, errors, loadErrors, daysDepth} = self.state;
        const {errorsName} = self.props;

        return (
            <div>
                <PageHeader
                    fixed
                    captionTruncate
                    notWrappedMaxHeight={null}
                    caption={
                        <h2 className="text-truncate">{FormatString(errorsName, daysDepth)}</h2>
                    }
                >
                    {self.renderForm()}
                </PageHeader>
                <div className="AppErrors">
                    <ErrorsBlockComponent errors={loadErrors} />
                    <table className="apperrors newstyle table-hover table-striped-even">
                        <thead>
                            <tr className="small">
                                <th className="text-right nowrap">#</th>
                                <th className="w-100">Message</th>
                                <th className="text-right nowrap">Errors</th>
                                <th className="text-right nowrap">Agents</th>
                                <th className="text-right nowrap">Accounts</th>
                                <th><div style={{width: CHART_WIDTH + 'px'}}>Dynamics</div></th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoaded && 
                                errors.map((item, index) => {
                                    const dataTable = item.StatsByDay;
                                    const minX = dataTable.rows[0].c[0].v;
                                    const maxX = dataTable.rows[dataTable.rows.length - 1].c[0].v;
                                    const maxY = Math.max(1, dataTable.rows.reduce((m, r) => m = Math.max(m, r.c[1].v), 0));

                                    return (
                                        <tr key={index}>
                                            <td  className="small text-secondary text-right nowrap">{index + 1}</td>
                                            <td className="w-100">
                                                <div className="small text-secondary">template hash #{item.MessageTemplateHashId}</div>
                                                <div className="verticaloverflow height-2 observe-resize">
                                                    {item.MessageTemplate}
                                                    {/* {Boolean(item.Message) && (item.Message != item.MessageTemplate) &&
                                                        <div className="verticaloverflow text-secondary">
                                                            <br/>
                                                            {item.Message}
                                                        </div>
                                                    } */}
                                                </div>
                                            </td>
                                            <td className="text-right nowrap">{numeral(item.TotalErrors).format('0,0')}</td>
                                            <td className="text-right nowrap">{numeral(item.TotalAgents).format('0,0')}</td>
                                            <td className="text-right nowrap">{numeral(item.TotalAccounts).format('0,0')}</td>
                                            <td>
                                                <SimpleLineChart 
                                                    dataTable={dataTable} 
                                                    options={{
                                                        width: CHART_WIDTH,
                                                        height: CHART_HEIGHT,
                                                        lineWidth: 1,
                                                        pointsVisible: false,
                                                        backgroundColor: 'transparent',
                                                        legend: { position: 'none' },
                                                        chartArea: { width: '100%', height: '100%' },
                                                        tooltip: { ignoreBounds: true, trigger: 'both' },
                                                        series: { 
                                                            0: { color: '#eb5757' } 
                                                        },
                                                        vAxis: {
                                                            ticks: [0],
                                                            viewWindow: {
                                                                min: -0.1 * maxY,
                                                                max: 1.1 * maxY
                                                            }
                                                        },
                                                        hAxis: {
                                                            baseline: minX, 
                                                            ticks: [minX],
                                                            viewWindow: {
                                                                min: minX - 0.5,
                                                                max: maxX + 0.5
                                                            }
                                                        },
                                                    }}
                                                    hiddenColumns={[2, 3]}
                                                />
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            {isLoaded && (errors.length == 0) &&
                                <tr><td colSpan={5}>no data</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}
AppErrorsComponent.propTypes = {
    errorsName: PropTypes.string,
    errorsSource: PropTypes.string.isRequired,
    versionFilterAllowed: PropTypes.bool,
    daysDepth: PropTypes.number.isRequired,
    errorsCount: PropTypes.number.isRequired,
    applicationTypeId: PropTypes.string,
    versionFilter: PropTypes.string,
    applicationTypes: PropTypes.arrayOf(PropTypes.shape({
        Key: PropTypes.string.isRequired,
        Value: PropTypes.string.isRequired
    })).isRequired,
}
AppErrorsComponent.defaultProps = {
    versionFilterAllowed: false,
    daysDepth: 10,
    errorsCount: 20,
    errorsName: 'Recent job errors ({0} days)',
}
